export default "__VITE_ASSET__2613f55d__"